/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
} from './PaymentState';

/**
 * 
 * @export
 * @interface PayOpenTableResponse
 */
export interface PayOpenTableResponse {
    /**
     * 
     * @type {PaymentState}
     * @memberof PayOpenTableResponse
     */
    paymentState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableResponse
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof PayOpenTableResponse
     */
    bookingReference: string;
    /**
     * 
     * @type {number}
     * @memberof PayOpenTableResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the PayOpenTableResponse interface.
 */
export function instanceOfPayOpenTableResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentState" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "bookingReference" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function PayOpenTableResponseFromJSON(json: any): PayOpenTableResponse {
    return PayOpenTableResponseFromJSONTyped(json, false);
}

export function PayOpenTableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayOpenTableResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentState': PaymentStateFromJSON(json['paymentState']),
        'paymentReference': json['paymentReference'],
        'bookingReference': json['bookingReference'],
        'amount': json['amount'],
    };
}

export function PayOpenTableResponseToJSON(value?: PayOpenTableResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentState': PaymentStateToJSON(value.paymentState),
        'paymentReference': value.paymentReference,
        'bookingReference': value.bookingReference,
        'amount': value.amount,
    };
}

